import React from "react";
import {SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export class MuteIcon extends React.Component {
    render() {
        return (
            <SvgIcon {...this.props}>
               <g transform="translate(-46 -83)">
                  <g transform="translate(-1 5)">
                     <g transform="translate(-282 -1167)">
                        <g fill="currentColor" transform="translate(1.68)">
                           <path d="M372.97,1146h-1.65a1.32,1.32,0,0,0-1.32,1.32v3.12a1.32,1.32,0,0,0,1.32,1.32h1.65a.15.15,0,0,0,.15-.15v-5.46a.15.15,0,0,0-.15-.15Zm0,0" transform="translate(-38.68 108.12)" />
                           <path d="M476.32,1068h-.72a.72.72,0,0,0-.437.148l-3.1,2.373a.149.149,0,0,0-.059.119v6.719a.15.15,0,0,0,.059.119l3.1,2.373a.72.72,0,0,0,.437.148h.72a.72.72,0,0,0,.72-.72v-10.56a.72.72,0,0,0-.72-.72Zm0,0" transform="translate(-136.6 183)" />
                        </g>
                     </g>
                     <g transform="translate(-1 -0.632)">
                        <line stroke="currentColor" x2="0.001" y2="5.656" transform="translate(67.129 88.632) rotate(45)" />
                        <line stroke="currentColor" x1="5.656" y1="0.001" transform="translate(63.132 88.632) rotate(45)" />
                     </g>
                  </g>
               </g>
            </SvgIcon>
        );
    }
}
